/** Fail-closed availability: only explicit true enables corporate CRM UI. */
export function isCorporateClientsAvailable(company) {
  return company?.corporate_clients_available === true;
}

export const TYPE_LABELS = {
  buyer: "Покупець",
  seller: "Продавець",
  both: "Покупець і продавець",
};

export const STATUS_LABELS = {
  lead: "Лід",
  active: "Активний",
  inactive: "Неактивний",
  closed: "Закритий",
};

export const typeLabel = (type) => TYPE_LABELS[type] || type || "—";
export const statusLabel = (status) => STATUS_LABELS[status] || status || "—";

export function clientDisplayName(client) {
  if (!client) return "—";
  const parts = [client.first_name, client.last_name].filter(Boolean);
  if (parts.length) return parts.join(" ");
  if (Object.prototype.hasOwnProperty.call(client, "phone") && client.phone) {
    return client.phone;
  }
  return client.public_id || `Клієнт #${client.id}`;
}

export function userDisplayName(user) {
  if (!user) return "—";
  const parts = [user.first_name, user.last_name].filter(Boolean);
  if (parts.length) return parts.join(" ");
  return user.handle || user.email || `Користувач #${user.id}`;
}

/** Keys that must stay absent when server omits confidential projection. */
export const CONFIDENTIAL_KEYS = [
  "phone",
  "email",
  "notes",
  "contacts",
  "preferences",
];

export function hasConfidentialKey(client, key) {
  if (!client || !key) return false;
  return Object.prototype.hasOwnProperty.call(client, key);
}

/**
 * Build PATCH body for corporate edit.
 * When confidential keys are absent from the server payload, never send them
 * (MEMBER grant can_edit without include_confidential).
 */
export function buildCorporatePatchBody(baseline, values) {
  const body = {};
  const safeKeys = [
    "first_name",
    "last_name",
    "type",
    "status",
    "source",
  ];
  for (const key of safeKeys) {
    const next = values[key] ?? "";
    const prev = baseline?.[key] ?? "";
    if (String(next) !== String(prev)) {
      body[key] = typeof next === "string" ? next.trim() : next;
    }
  }
  for (const key of CONFIDENTIAL_KEYS) {
    if (key === "contacts" || key === "preferences") continue;
    if (!hasConfidentialKey(baseline, key)) continue;
    const next = values[key] ?? "";
    const prev = baseline?.[key] ?? "";
    if (String(next) !== String(prev)) {
      body[key] = typeof next === "string" ? next.trim() : next;
    }
  }
  return body;
}

export function emptyFormFromClient(client) {
  const form = {
    first_name: client?.first_name || "",
    last_name: client?.last_name || "",
    type: client?.type || "buyer",
    status: client?.status || "lead",
    source: client?.source || "",
  };
  for (const key of ["phone", "email", "notes"]) {
    if (hasConfidentialKey(client, key)) {
      form[key] = client[key] || "";
    }
  }
  return form;
}
